import { ButtonProps, Button } from "@chakra-ui/react";

export interface BrandButtonProps extends ButtonProps {
  children: React.ReactNode;
  size?: "xs" | "sm" | "md" | "lg" | "default";
  type?: "button" | "reset" | "submit";
}

export const BrandButton = ({
  children,
  size = "md",
  type = "button",
  ...props
}: BrandButtonProps) => {
  const sizes = {
    xs: {
      paddingX: "12px",
      paddingY: "16px",
      fontSize: "12px",
      height: "24px",
      borderRadius: "6px",
    },
    sm: {
      paddingX: "12px",
      paddingY: "8px",
      fontSize: "14px",
      height: "28xp",
      borderRadius: "8px",
    },
    md: {
      paddingX: "24px",
      paddingY: "12px",
      fontSize: "16px",
      height: "48px",
      borderRadius: "6px",
    },
    lg: {
      paddingX: "28px",
      paddingY: "24px",
      fontSize: "16px",
      height: "56px",
      borderRadius: "6px",
    },
    default: {
      paddingX: "24px",
      paddingY: "12px",
      fontSize: "16px",
      height: "40px",
      borderRadius: "6px",
    },
  };

  return (
    <Button
      type={type}
      background="linear-gradient(to right, #7652f7, #9500ff)"
      textColor="white"
      px={sizes[size].paddingX}
      py={sizes[size].paddingY}
      height={sizes[size].height}
      borderRadius="12px"
      fontSize={sizes[size].fontSize}
      fontWeight="600"
      // boxShadow="0 4px 20px rgba(118, 82, 247, 0.4)"
      // border="1px solid"
      borderColor="brand.600"
      _hover={{
        background: "linear-gradient(to right, #7652f7, #9500ff)",
        transform: "translateY(-1px)",
        boxShadow: "0 6px 20px rgba(118, 82, 247, 0.4)",
      }}
      _active={{
        background: "linear-gradient(to right, #6b46c1, #7c3aed)",
        transform: "translateY(0px)",
      }}
      transition="all 0.2s ease"
      {...props}
    >
      {children}
    </Button>
  );
};
